import * as React from 'react';
import { useSelector } from 'react-redux';

import { useDesktopBlackFridayActive } from './hooks';
import { Layout, LayoutBlock, Main, MainContent } from '../../components/Page';
import { PageLoader } from '../../components/PageLoader';
import { selectLoading } from '../../selectors/appStatus';
import { BankListContainer } from '../BankList';
import { BlackFridayBannerContainer } from '../BlackFridayBannerContainer';
import { BuildersPromotionsContainer } from '../BuildersPromotionsContainer';
import { CategoriesContainer } from '../CategoriesContainer';
import { CoPromosContainer } from '../CoPromosContainer';
import { FlightBannerContainer } from '../FlightBannerContainer';
import { FreshPromoListContainer } from '../FreshPromoList';
import { HeadCategoriesContainer } from '../HeadCategoriesContainer';
import { ListingCompilationsContainer } from '../ListingCompilationsContainer';
import { LowRateMortgagePromosContainer } from '../LowRateMortgagePromosContainer';
import { MortgageContainer } from '../MortgageContainer';
import { MortgageProgramsContainer } from '../MortgageProgramsContainer';
import { PageHeaderContainer } from '../PageHeaderContainer';
import { PromoCompilationsContainer } from '../PromoCompilation';

export const PageContainer: React.FC = () => {
  const isLoading = useSelector(selectLoading);

  const isDesktopBlackFridayActive = useDesktopBlackFridayActive();

  return (
    <Main>
      <Layout>
        <PageHeaderContainer />
      </Layout>
      <MainContent>
        <LayoutBlock>
          <HeadCategoriesContainer />
        </LayoutBlock>
        <LayoutBlock>
          <FlightBannerContainer />
        </LayoutBlock>
        {isDesktopBlackFridayActive ? (
          <>
            <LayoutBlock>
              <BlackFridayBannerContainer />
            </LayoutBlock>
            <LayoutBlock>
              <CoPromosContainer />
            </LayoutBlock>
            <LayoutBlock>
              <ListingCompilationsContainer />
            </LayoutBlock>
          </>
        ) : (
          <LayoutBlock>
            <PromoCompilationsContainer />
          </LayoutBlock>
        )}
        <LayoutBlock>
          <FreshPromoListContainer />
        </LayoutBlock>
        {!isDesktopBlackFridayActive && (
          <LayoutBlock>
            <BuildersPromotionsContainer />
          </LayoutBlock>
        )}
        <LayoutBlock>
          <LowRateMortgagePromosContainer />
        </LayoutBlock>
        <LayoutBlock>
          <BankListContainer />
        </LayoutBlock>
        <LayoutBlock>
          <MortgageProgramsContainer />
        </LayoutBlock>
        <LayoutBlock>
          <MortgageContainer />
        </LayoutBlock>
        <LayoutBlock>
          <CategoriesContainer />
        </LayoutBlock>
      </MainContent>
      {isLoading && <PageLoader />}
    </Main>
  );
};
